import { Box, Text, TextInput, Checkbox, Flex, Button } from "@mantine/core"
import { Controller, useForm } from "react-hook-form"
import { Playlist, PlaylistParams } from "../../client"

interface PlaylistFormProps {
  title: string,
  submitText: string,
  playlist: Playlist | null,
  onSubmit: (data: PlaylistParams) => void
}

const PlaylistForm: React.FC<PlaylistFormProps> = ({ title, submitText, playlist, onSubmit }) => {
  const { handleSubmit, control } = useForm({
    defaultValues: playlist ? {
      name: playlist.name,
      description: playlist.description,
      image: playlist.thumbnailUrl,
      private: playlist.private
    } : {
      name: "",
      description: "",
      image: "",
      private: true
    },
    mode: "onChange",
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box>
        <Flex display={"flex"} flex={1} direction={"column"} align={"center"}>
          <Text ta={"center"} fw={600} fz={"h4"}>{title}</Text>
        </Flex>

        <Controller
          data-autofocus
          name="name"
          control={control}
          rules={{
            required: "Name is required",
            minLength: {value: 1, message: "Name cannot be empty"},
            maxLength: {value: 50, message: "Name must be under 50 characters"},
          }}
          render={({ field, fieldState: { error } }) => (
            <TextInput
              {...field}
              styles={{
                root: {
                  padding: 10,
                  paddingBottom: 0,
                },
                input: {
                  borderRadius: 10
                }
              }}
              data-testid={"name"}
              label="Name"
              error={error?.message}
              onChange={(value) => field.onChange(value)}
              value={field.value}
            />
          )}
        />

        <Controller
          data-autofocus
          name="description"
          control={control}
          rules={{
            maxLength: {value: 200, message: "Description must be under 200 characters"}
          }}
          render={({ field, fieldState: { error }}) => (
            <TextInput
              {...field}
              styles={{
                root: {
                  padding: 10,
                  paddingTop: 5,
                  paddingBottom: 0,
                },
                input: {
                  borderRadius: 10
                }
              }}
              data-testid={"description"}
              label="Description"
              error={error?.message}
              onChange={(value) => field.onChange(value)}
              value={field.value}
            />
          )}
        />

        <Controller
          name="private"
          control={control}
          render={({ field }) => (
            <Checkbox
              style={{
                padding: 12,
                paddingTop: 20
              }}
              data-testid={"private"}
              label="Private"
              onChange={(value) => field.onChange(value)}
              checked={!!field.value}
            />
          )}
        />

        <Flex flex={1} justify={"center"} p={10}>
          <Button w={"100%"} radius={15} size="sm" type="submit">{submitText}</Button>
        </Flex>
      </Box>
  </form>
  )
}

export default PlaylistForm